import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EyeClosed from './icon-eye-closed.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EyeClosed {...validProps} />;
}
SvgComponent.iconName = 'eyeClosed';

/**
 * @deprecated This is a legacy icon
 */
export const EyeClosedIcon = svgIconWrapper(SvgComponent);
